import { useUpsertLocationPersonalizationMutation } from './mutations';
import { getGetLocationPersonalizationQueryKey, useGetLocationPersonalizationQuery } from './queries';

export const EmailRecordsV1 = {
  Mutations: {
    useUpsertLocationPersonalizationMutation,
  },
  Queries: {
    getGetLocationPersonalizationQueryKey,
    useGetLocationPersonalizationQuery,
  },
};
